"use client";

import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { defaultLocale, getLocaleFromPathname, type Locale } from "@/lib/i18n";
import { getPageTranslation, getTranslation } from "@/lib/translations";

interface HomepageContactSectionProps {
  locale?: Locale;
}

export function HomepageContactSection({ locale }: HomepageContactSectionProps) {
  const location = useLocation();
  const currentLocale = locale || getLocaleFromPathname(location.pathname);
  const pt = getPageTranslation(currentLocale);
  const t = getTranslation(currentLocale);
  
  const contactPath = currentLocale === defaultLocale ? `/${t.routes.contact}` : `/${currentLocale}/${t.routes.contact}`;

  return (
    <section className="py-16 md:py-24 bg-white dark:bg-background">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-2xl md:text-[45px] font-normal tracking-wide leading-relaxed mb-12 text-foreground">
            {pt.homepageContact.title}
          </h2>
          <Link to={contactPath}>
            <Button 
              size="default" 
              className="w-full md:w-auto bg-primary hover:bg-primary/90 text-white px-6 py-3 text-sm"
            >
              {pt.homepageContact.button}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}